<template>
    <div class="auth-wrapper auth-v1 px-2">
        <div class="auth-inner py-2">
            <b-card class="mb-0">

                <b-link class="brand-logo">
                    <b-img src="@/assets/images/logo/logo.png" alt="logo" class="logo-image" />
                    <h2 class="brand-text text-primary ml-1">
                        ObjectifEval
                    </h2>
                </b-link>
                <div class="otp-container">
                    <b-card-title class="mb-1">
                        Entrer le code OTP reçu par mail
                    </b-card-title>
                    <div class="otp-inputs">
                        <input 
                        v-for="(digit, index) in otpDigits" 
                        :key="index" 
                        v-model="otpCode[index]" 
                        ref="otpInput"
                        type="text" 
                        maxlength="1" 
                        @input="focusNextInput(index)" 
                        @keydown.backspace="focusPrevInput(index)"
                        @paste="handlePaste($event)" 
                    />
                    </div>
                    <b-button variant="primary" block type="submit" @click="submitOTP">
                        Connecter
                    </b-button>
                    <b-button variant="link" block @click="resendOTP">
                        Renvoyer le code
                    </b-button>
                </div>
            </b-card>
        </div>
    </div>
</template>

<script>
import { BCard, BLink, BButton, BCardTitle, BImg } from 'bootstrap-vue'
import { authenticateUser, resendOtp } from '@/services/LoginService'
import { setAuthToken } from '@/auth/auth';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
export default {
    components: {
        BCard,
        BLink,
        BCardTitle,
        BButton,
        BImg,
        //eslint-disable-next-line vue/no-unused-components
        ToastificationContent,
    },
    data() {
        return {
            otpCode: ['', '', '', '', '', ''], // Tableau pour stocker le code OTP
            otpDigits: [0, 1, 2, 3, 4, 5], // Tableau pour générer les cases du formulaire
            methodData: null, // Variable pour stocker methodData
        };
    },
    methods: {
        // Fonction pour passer automatiquement au champ suivant lorsqu'un chiffre est entré
        focusNextInput(index) {
            if (index < this.otpCode.length - 1 && this.otpCode[index]) {
                this.$refs.otpInput[index + 1].focus();
            }
        },
        // Fonction pour soumettre le code OTP
        submitOTP() {
            const otp = this.otpCode.join('');

            if (this.methodData) {
                const loginRequest = {
                    username: this.methodData.username,
                    password: otp
                };

                authenticateUser(loginRequest)
                    .then(response => {
                        // localStorage.setItem('token', response.token);
                        // localStorage.setItem('userData', JSON.stringify(response.userData));
                        this.$store.commit("user/setUserData", response)
                        // this.$store.commit("user/setToken", response.token)


                        // Rediriger vers une route protégée ou la page d'accueil après la connexion
                        this.$router.push({ name: 'home' });
                    })
                    .catch(error => {
                        console.error('Erreur lors de l\'authentification :', error);
                        this.$toast({
                            component: ToastificationContent,
                            props: {
                                title: "Le code OTP saisi est incorrect.",
                                icon: 'AlertCircleIcon',
                                variant: 'danger',
                                timeout: 10000,
                            },
                        })
                    });


            } else {
                console.error('MethodData is not available.');
            }
        },
        // Fonction pour gérer le collage du code OTP
        handlePaste(event) {
            const pasteData = event.clipboardData.getData('text');
            if (pasteData.length === this.otpCode.length) {
                this.otpCode = pasteData.split('');
                this.$refs.otpInput[this.otpCode.length - 1].focus();
            }
        },
        focusPrevInput(index) {
        if (!this.otpCode[index] && index > 0) {
            this.$refs.otpInput[index - 1].focus();
        }
    },
        // Fonction pour renvoyer le code OTP
        resendOTP() {
            if (this.methodData) {
                resendOtp(this.methodData)
                    .then(response => {
                    })
                    .catch(error => {
                        console.error('Erreur lors du renvoi du code OTP :', error);
                    });
            } else {
                console.error('MethodData is not available.');
            }
        },
    },
    created() {
        const methodData = localStorage.getItem('methodData');
        if (methodData) {
            this.methodData = JSON.parse(methodData);
        } else {
            console.error('No method data available.');
        }
    },
    // Autres options du composant
};
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/pages/page-auth.scss';

.otp-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
}

.otp-inputs {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

input {
    width: 40px;
    height: 40px;
    text-align: center;
    margin: 0 5px;
    font-size: 18px;
}

.logo-image {
    height: 40px;
    /* Ajuste selon la taille souhaitée */
    margin-right: 1px;
}
</style>
